import type { MutationHookOptions } from '@apollo/client'
import {
  CreateTrainingsSettingsDocument,
  CreateTrainingsSettingsMutation,
  CreateTrainingsSettingsMutationVariables,
  GetTrainingsSettingsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  CreateTrainingsSettingsMutation,
  CreateTrainingsSettingsMutationVariables
>

export const useCreateSetting = (options?: Options) => {
  const [createSetting, { loading }] = useMutation(CreateTrainingsSettingsDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.createTrainingsSetting,
  })

  return {
    loading,
    create(variables: CreateTrainingsSettingsMutationVariables) {
      return createSetting({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [GetTrainingsSettingsDocument],
      })
    },
  }
}
